export default __webpack_public_path__ + "static/media/teacher.ba3e9327.png";